export interface ExternalConnectionTO {
  provider: string;
  status: 'ACTIVE' | 'PENDING' | 'ERROR' | 'DISCONNECTED';
  latestDataAt?: string;
  latestDataType?: string;
}

export const toExternalConnectionTO = (item: any): ExternalConnectionTO => ({
  provider: item.provider,
  status: item.status,
  latestDataAt: item.latestDataAt,
  latestDataType: item.latestDataType,
});
